(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('appraisal-firm-location', {
            parent: 'entity',
            url: '/appraisal-firm-location?page&sort&search',
            data: {
                authorities: [/^ROLE_(ADMIN|VC|APPRAISAL|APPRAISER).*/gi],
                pageTitle: 'valueconnectApp.appraisalFirmLocation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/appraisal-firm-location/appraisal-firm-locations.html',
                    controller: 'AppraisalFirmLocationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appraisalFirmLocation');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('address');
                    return $translate.refresh();
                }]
            }
        })
        .state('appraisal-firm-location-detail', {
            parent: 'entity',
            url: '/appraisal-firm-location/{id}',
            data: {
                authorities: [/^ROLE_(ADMIN|VC|APPRAISAL|APPRAISER).*/gi],
                pageTitle: 'valueconnectApp.appraisalFirmLocation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/appraisal-firm-location/appraisal-firm-location-detail.html',
                    controller: 'AppraisalFirmLocationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appraisalFirmLocation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AppraisalFirmLocation', function($stateParams, AppraisalFirmLocation) {
                    return AppraisalFirmLocation.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('appraisal-firm-location.new', {
            parent: 'appraisal-firm-location',
            url: '/new',
            data: {
                authorities: [/^ROLE_(ADMIN|VC|APPRAISAL).*/gi]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/appraisal-firm-location/appraisal-firm-location-dialog.html',
                    controller: 'AppraisalFirmLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                officeName: null,
                                disabled: false,
                                id: null
                            };
                        }
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('appraisalFirmLocation');
                        $translatePartialLoader.addPart('address');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }).result.then(function() {
                    $state.go('appraisal-firm-location', null, { reload: true });
                }, function() {
                    $state.go('appraisal-firm-location');
                });
            }]
        })
        .state('appraisal-firm-location.edit', {
            parent: 'appraisal-firm-location',
            url: '/{id}/edit',
            data: {
                authorities: [/^ROLE_(ADMIN|VC|APPRAISAL).*/gi]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/appraisal-firm-location/appraisal-firm-location-dialog.html',
                    controller: 'AppraisalFirmLocationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppraisalFirmLocation', function(AppraisalFirmLocation) {
                            return AppraisalFirmLocation.get({id : $stateParams.id}).$promise;
                        }]
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('appraisalFirmLocation');
                        $translatePartialLoader.addPart('address');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }).result.then(function() {
                    $state.go('appraisal-firm-location', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('appraisal-firm-location.delete', {
            parent: 'appraisal-firm-location',
            url: '/{id}/delete',
            data: {
                authorities: [/^ROLE_(ADMIN|VC|APPRAISAL).*/gi]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/appraisal-firm-location/appraisal-firm-location-delete-dialog.html',
                    controller: 'AppraisalFirmLocationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AppraisalFirmLocation', function(AppraisalFirmLocation) {
                            return AppraisalFirmLocation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('appraisal-firm-location', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
